// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW6_buttonsContainer__P1+5v","editableSpanContainer":"HW6_editableSpanContainer__eMm+V"};